'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconFloppyDisk, iconFloppyDiskTag } from '@ni/nimble-components/dist/esm/icons/floppy-disk';
import { wrap } from '../../utilities/react-wrapper';

export type { IconFloppyDisk };
export { iconFloppyDiskTag };
export const NimbleIconFloppyDisk = wrap(IconFloppyDisk);